module.exports = __webpack_public_path__ + "static/media/Baslik.70f92002.png";